import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { MatTableModule } from "@angular/material/table";
import { CostGridBlockContentComponent } from "./cost-grid-block-content.component";
import { BlockTitleModule } from "../../../../../../../libraries/component/table/block-title/block-title.module";
import { BlockAddRemoveButtonModule } from "./components/block-add-remove-button/block-add-remove-button.module";
import { CostFormGeneratorModule } from '../../../../services/cost-form-generator/cost-form-generator.module';
import { BlockSupplierModule } from "./components/block-supplier/block-supplier.module";
import { TdDayModule } from "libraries/component/table/td-day/td-day.module";
import { TdSeparatorModule } from "app_quotation/shared/components/table/block-content/td-separator/td-separator.module";
import { QuotationPricePipesModule } from "app_quotation/shared/pipes/quotation-price-pipes.module";

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        TdSeparatorModule,
        BlockTitleModule,
        BlockSupplierModule,
        CostFormGeneratorModule,
        BlockAddRemoveButtonModule,
        TdDayModule,
        QuotationPricePipesModule,

    ],
    exports: [
        CostGridBlockContentComponent
    ],
    declarations: [
        CostGridBlockContentComponent
    ],
    providers: [],
})
export class CostGridBlockContentModule {
}
